import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setMessage } from "../message/Message";
import GroupService from "../../../services/AdminServices/GroupService";

const initialState = {
  allGroupData: [],
  gruopImage:[],
  gruopImageload: false,
  loading: false,
  nonRecipients:[],
  nonRecipientsLoading: false,
  deleteUserInGroups:[],
  deleteUserInGroupsLoad: false,
  addUserInGruop:[],
  addUserInGruopLOad:false,
  groupDetail:[],
  groupDetailLOad:false
};

export const allUserGroups = createAsyncThunk(
  "group/allgroups",
  async (id, thunkAPI) => {
    
    try {
      const response = await GroupService.allUserGroups(id);

      return { data: response.data.data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const allnonRecipients = createAsyncThunk(
  "group/allnonRecipients",
  async (data, thunkAPI) => {

    try {
      const response = await GroupService.nonRecipients(data);

      return { data: response.data.data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createGroups = createAsyncThunk(
  "group/createGroups",
  async ({ name, description, userId, imageName }, thunkAPI) => {
    try {
      
      const response = await GroupService.createGroups(
        name,
        description,
        userId,
        imageName
      );

      return { createGroup: response.data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const deleteGroups = createAsyncThunk(
  "group/deleteGroups",
  async (id, thunkAPI) => {
    
    try {
      const response = await GroupService.deleteGroups(id);

      return { deleteGroupData: response.data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateGroup = createAsyncThunk(
  "groups/updateGroup",
  async (payload, { rejectWithValue }) => {
    
    try {
      const response = await GroupService.updateGroup(payload); // API call to update the group
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addGroupImage = createAsyncThunk(
  "groups/addGroupImage",
  async (payload, { rejectWithValue }) => {
    
    try {
      const response = await GroupService.uploadGroupImage(payload); // API call to update the group
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteUserInGroups = createAsyncThunk(
  "group/deleteUserInGroups",
  async (data, thunkAPI) => {
    
    try {
      const response = await GroupService.deleteUserInGroups(data);

      return { deleteGroupData: response.data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const addUserInGruop = createAsyncThunk(
  "groups/addUserInGruop",
  async (payload, { rejectWithValue }) => {
    
    try {
      const response = await GroupService.addUserInGruop(payload); // API call to update the group
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const groupDetail = createAsyncThunk(
  "groups/groupDetail",
  async (payload, { rejectWithValue }) => {
    
    try {
      const response = await GroupService.GroupDetail(payload); // API call to update the group
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


const GroupSlice = createSlice({
  name: "group",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(allUserGroups.pending, (state) => {
        state.loading = true;
      })
      .addCase(allUserGroups.fulfilled, (state, action) => {
        
        state.allGroupData = action.payload.data;
        state.loading = false;
      })
      .addCase(allUserGroups.rejected, (state) => {
        state.allGroupData = [];
        state.loading = false;
      })



      .addCase(allnonRecipients.pending, (state) => {
        state.nonRecipientsLoading = true;
      })
      .addCase(allnonRecipients.fulfilled, (state, action) => {
        state.nonRecipients = action.payload.data;
        state.nonRecipientsLoading = false;
      })
      .addCase(allnonRecipients.rejected, (state) => {
        state.nonRecipients = [];
        state.nonRecipientsLoading = false;
      })


      .addCase(deleteUserInGroups.pending, (state) => {
        state.deleteUserInGroupsLoad = true;
      })
      .addCase(deleteUserInGroups.fulfilled, (state, action) => {
        state.deleteUserInGroups = action.payload.data;
        state.deleteUserInGroupsLoad = false;
      })
      .addCase(deleteUserInGroups.rejected, (state) => {
        state.deleteUserInGroups = [];
        state.deleteUserInGroupsLoad = false;
      })




      .addCase(createGroups.pending, (state) => {
        state.loading = true;
      })
      .addCase(createGroups.fulfilled, (state, action) => {
        // state.allGroupData = [...state.allGroupData, action.payload.data];
        state.loading = false;
      })
      .addCase(createGroups.rejected, (state) => {
        state.createGroup = [];
        state.loading = false;
      })
      .addCase(deleteGroups.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteGroups.fulfilled, (state, action) => {
        
        // console.log("Group IDs:", state.allGroupData); // Logs all IDs in allGroupData
        // console.log("Arg (ID to delete):", action.meta.arg); // Logs the ID passed to the thunk

        // state.allGroupData = state.allGroupData.filter((group) => {
        //   console.log(
        //     "Checking group.id:",
        //     group.id,
        //     "against arg:",
        //     action.meta.arg
        //   );
        //   return group.id !== action.meta.arg;
        // });

        // state.deleteGroupData = action.payload.deleteGroupData;
        state.loading = false;
      })
      .addCase(deleteGroups.rejected, (state) => {
        state.deleteGroupData = [];
        state.loading = false;
      })



      .addCase(addGroupImage.pending, (state) => {
        state.loading = true;
      })
      .addCase(addGroupImage.fulfilled, (state, action) => {
        console.log("addGroupImage action",action)
        state.gruopImage = action.payload.data.imageName;
        state.loading = false;
      })
      .addCase(addGroupImage.rejected, (state) => {
        state.gruopImage = [];
        state.loading = false;
      })



      .addCase(addUserInGruop.pending, (state) => {
        state.addUserInGruopLOad = true;
      })
      .addCase(addUserInGruop.fulfilled, (state, action) => {
        console.log("addGroupImage action",action)
        state.addUserInGruop = action.payload.data;
        state.addUserInGruopLOad = false;
      })
      .addCase(addUserInGruop.rejected, (state) => {
        state.addUserInGruop = [];
        state.addUserInGruopLOad = false;
      })


      .addCase(groupDetail.pending, (state) => {
        state.groupDetailLOad = true;
      })
      .addCase(groupDetail.fulfilled, (state, action) => {
        console.log("addGroupImage action",action)
        state.groupDetail = action.payload.data;
        state.groupDetailLOad = false;
      })
      .addCase(groupDetail.rejected, (state) => {
        state.groupDetail = [];
        state.groupDetailLOad = false;
      })
  },
});

const { reducer } = GroupSlice;
export default reducer;
